import { getInstance } from './authWrapper'

export const globalGuard = (to, from, next) => {
    const authService = getInstance()

    const fn = async function() {
        const routeRoles = to.meta.roles || []

        if (authService.isAuthenticated) {
            await authService.getMe()

            const userRole = authService.getUserForPortalAccess().user_type

            // If it is a public route or the user has the corresponding role
            if (routeRoles.length === 0 || routeRoles.includes(userRole)) {
                return next()
            }

            return next({ name: 'unauthorized' })
        } else if (!to.query.error) {
            // If it is a public route
            if (routeRoles.length === 0) {
                return next()
            }

            await authService.loginWithRedirect({
                appState: { targetUrl: to.fullPath },
            })
        } else {
            return next({ name: 'verify' })
        }
    }

    if (!authService.loading) {
        return fn()
    }

    authService.$watch('loading', loading => {
        if (loading === false) {
            return fn()
        }
    })
}
